import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1 -5 5h-6v-16","key":"svg-0"}]]

const IconLetterD = createReactComponent('outline', 'letter-d', 'LetterD', __iconNode);

export default IconLetterD;